/**
 * TicketedEventSeatingGroup Entity Schemas
 *
 * A named table at an event — a gala table of ten — that registrations are
 * assigned to (plan 2026-09-09-1309, U15 — R3, R35; KTD12). Capacity is a
 * REPORTED limit: assigning past it succeeds, and the group says how many it
 * is over. Admin copy calls it a "table".
 *
 * Per KTD8 `id` is the public id and nothing here is a BigInt.
 */

import { z } from 'zod'

/** Seats at one table. Null means no limit. */
export const SeatingGroupCapacitySchema = z.number().int().min(0).max(10_000)

export const TicketedEventSeatingGroupSchema = z.object({
  id: z.string(),
  name: z.string(),
  capacity: SeatingGroupCapacitySchema.nullable(),
  sortOrder: z.number().int(),
  /** Live registrations (active and deactivated) at this table; cancelled and voided ones are not counted. */
  assignedCount: z.number().int().min(0),
  /** Seats still free, never below 0; null when the table has no capacity. */
  remaining: z.number().int().min(0).nullable(),
  /** How many live registrations the table holds past its capacity; 0 when within it or unlimited. */
  overCount: z.number().int().min(0),
  createdAt: z.string(),
  updatedAt: z.string().nullable()
})
export type TicketedEventSeatingGroup = z.infer<typeof TicketedEventSeatingGroupSchema>
